import { trace } from 'owa-trace';

interface PersistedFavoriteNode {
    id: string;
    type: number;
    displayName?: string;
    personaSearchFolderId?: string;
    personaEmail?: string;
    personaAllEmails?: string[];
}

/**
 * Parse a single raw node to folder node
 * @param rawNode the raw favorite node data as string
 * @return folder id
 */
export function parse(rawNode: string): string {
    let parsedNode;

    try {
        parsedNode = JSON.parse(rawNode) as PersistedFavoriteNode;
    } catch (error) {
        trace.warn('Cannot parse folderForestNode: ' + rawNode);
        return undefined;
    }

    // Make sure the node has valid id and the node type is folder(type 0 means folder node)
    return parsedNode.id && parsedNode.type === 0 ? parsedNode.id : undefined;
}

/**
 * Serialize the favorite nodes
 * @param orderedFavoritesFolderIds the ordered favorites node ids
 * @param originalFavoriteNodes the original favorite nodes in user option FavoriteNodes
 * @return an array of serialized node data as string
 */
export function serialize(
    orderedFavoritesFolderIds: string[],
    originalFavoriteNodes: readonly string[]
): string[] {
    const favoriteNodesRaw = orderedFavoritesFolderIds.map(nodeId => {
        const persistedNode: PersistedFavoriteNode = {
            id: nodeId,
            type: 0 /* type 0 means folder*/,
        };
        return JSON.stringify(persistedNode);
    });

    if (originalFavoriteNodes) {
        originalFavoriteNodes.forEach(rawNode => {
            const parsedNode = JSON.parse(rawNode) as PersistedFavoriteNode;
            // If the parsed node is not folder node, add it to the favorite nodes raw array.
            if (parsedNode.type !== 0) {
                favoriteNodesRaw.push(rawNode);
            }
        });
    }

    return favoriteNodesRaw;
}
